import { useEffect } from 'react';
import { useFormState, dateHelper } from 'shared';

export function useReaderRequestForm(readerRequest, onChangeInput) {
  const [readerRequestInputs, setReaderInputs] = useFormState(readerRequest, onChangeInput);

  useEffect(() => {
    setReaderInputs(
      {
        ...readerRequest,
        formattedReadingStartDate:
          readerRequest?.readingStartDate && dateHelper.toLongDate(readerRequest?.readingStartDate, true),
        formattedReadingEndDate:
          readerRequest?.readingEndDate && dateHelper.toLongDate(readerRequest?.readingEndDate, true)
      },
      false
    );
  }, [readerRequest]);

  return {
    readerInputs: readerRequestInputs
  };
}
